import React from 'react';
import styled, { css } from 'styled-components';

import theme from '@styles/theme';
import { FlexBox } from '@components/styled/StyledComponents';
const DATA = [
    { time: '00:00', status: 'inactive' },
    { time: '00:15', status: 'inactive' },
    { time: '00:30', status: 'inactive' },
    { time: '00:45', status: 'inactive' },
    { time: '01:00', status: 'inactive' },
    { time: '01:15', status: 'inactive' },
    { time: '01:30', status: 'inactive' },
    { time: '01:45', status: 'inactive' },
    { time: '02:00', status: 'inactive' },
    { time: '02:15', status: 'inactive' },
    { time: '02:30', status: 'success' },
    { time: '02:45', status: 'success' },
    { time: '03:00', status: 'success' },
    { time: '03:15', status: 'success' },
    { time: '03:30', status: 'success' },
    { time: '03:45', status: 'error' },
    { time: '04:00', status: 'success' },
    { time: '04:15', status: 'success' },
    { time: '04:30', status: 'success' },
    { time: '04:45', status: 'success' },
    { time: '05:00', status: 'success' },
    { time: '05:15', status: 'success' },
    { time: '05:30', status: 'success' },
    { time: '05:45', status: 'success' },
    { time: '06:00', status: 'success' },
    { time: '06:15', status: 'error' },
    { time: '06:30', status: 'error' },
    { time: '06:45', status: 'success' },
    { time: '07:00', status: 'success' },
    { time: '07:15', status: 'success' },
    { time: '07:30', status: 'success' },
    { time: '07:45', status: 'success' },
    { time: '08:00', status: 'success' },
    { time: '08:15', status: 'success' },
    { time: '08:30', status: 'success' },
    { time: '08:45', status: 'error' },
    { time: '09:00', status: 'success' },
    { time: '09:15', status: 'success' },
    { time: '09:30', status: 'success' },
    { time: '09:45', status: 'success' }
];
type GaugeGraphProps = {
    data?: any[];
    title?: string;
};
const GaugeGraph = ({ data, title }: GaugeGraphProps) => {
    const getTimeStep = (time: string) => {
        const [hour, minutes] = time.split(':').map(Number);
        return hour * 4 + minutes / 15;
    };
    const getStepColor = (status: string) => {
        return status === 'success'
            ? theme.colors.activeGreen
            : status === 'error'
            ? theme.colors.activeOrange
            : theme.colors.ultraLightGrayBorder;
    };

    return (
        <FlexBox>
            {title && <Title>{title}</Title>}
            <GraphWrapper>
                <GaugeWrapper>
                    {[...Array(96)].map((_, index) => {
                        if (!DATA[index]) {
                            return <Step key={index} />;
                        }
                        if (index === getTimeStep(DATA[index].time)) {
                            return (
                                <Step
                                    key={index}
                                    $bgColor={getStepColor(DATA[index].status)}
                                />
                            );
                        }
                    })}
                </GaugeWrapper>
                <TimeWrapper>
                    {[...Array(25)].map((_, index) => (
                        <Hour key={index}>
                            {String(index).padStart(2, '0')}
                        </Hour>
                    ))}
                </TimeWrapper>
            </GraphWrapper>
        </FlexBox>
    );
};

export default GaugeGraph;

const Title = styled.div`
    width: 70px;
    font-size: 16px;
    font-family: PretendardMedium, sans-serif;
`;
const GraphWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
`;

const GaugeWrapper = styled.div`
    display: flex;
    gap: 1px;
    margin-bottom: 8px;
`;

const Step = styled.span<{ $bgColor?: string }>`
    display: inline-block;
    width: 8px;
    height: 20px;
    border-radius: 2px;
    background-color: ${({ $bgColor }) =>
        $bgColor ? $bgColor : theme.colors.ultraLightGrayBorder};
`;

const TimeWrapper = styled.div`
    display: flex;
    gap: 16px;
`;

const Hour = styled.span`
    display: inline-block;
    width: 20px;
    font-size: 14px;
    color: ${theme.colors.deepGrayFontColor};
`;
